import React from 'react';
import { useLocation } from 'react-router-dom';

const PageBanner = () => {
  const location = useLocation(); // Gets the current path

  // Define a mapping of routes to page names
  const pageNames = {
    '/about': 'About Us',
    '/service': 'Our Services',
    '/contact': 'Contact Us',
    '/career': 'Career',
    '/gallery': 'Gallery',
  };

  // Get the page name based on the current path
  const pageTitle = pageNames[location.pathname] || 'Welcome';

  return (
    <section className="page-banner section-padding">
      <div className="container">
        <h1>{pageTitle}</h1>
      </div>
    </section>
  );
};

export default PageBanner;
